import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Dispatch} from "redux";
import {toast} from "react-hot-toast";
import {useGetOrderedPrescription} from "../../../../hook/request/ihioPrescriptionFilling";
import {IhioReferencePrescriptionType} from "../../../../types/ihioPrescription";
import Modal from "../../general/modal";
import {
    isHideModalDataSelector,
    isShowModalDataSelector,
    modalDataSelector,
    modalNameSelector
} from "../../../../store/selector/general";
import {general} from "../../../../store/action";
import {v4 as uuidv4} from "uuid";
import OrderedPrescriptionItem from "./orderedPrescriptionItemCard";
import OrderPartnerInfo from "./orderPartnerInfo";
import Icon from "../../general/icon";

type ModalInfoProps = {
    nationalCode?: string;
    samadCode?: string;
}

type OrderedPrescriptionInfoModalProps = {
    modalData: any;
    modalName: string;
    isShowModalData: boolean;
    handleHideModal: any;
    handleResetModal: any;
}

const OrderedPrescriptionInfoModal = ({
    modalData,
    modalName,
    isShowModalData,
    handleHideModal,
    handleResetModal,
}: OrderedPrescriptionInfoModalProps) => {

    const navigate = useNavigate();

    const [showState, setShowState] = useState(false);
    const [modalInfo, setModalInfo] = useState<ModalInfoProps>({});
    const [orderedPrescriptionData, setOrderedPrescriptionData] = useState<IhioReferencePrescriptionType>()


    const getOrderedPrescriptionRequest = useGetOrderedPrescription();

    useEffect(() => {
        if(
            isShowModalData &&
            modalName === 'orderedPrescriptionInfo'
        ){
            setShowState(true);
            setModalInfo(modalData);
            handleResetModal();
        }
    }, [modalData, modalName])


    useEffect(() => {
        if(modalInfo) {
            getOrderedPrescriptionRequest.mutate({nationalCode: modalInfo?.nationalCode, samadCode: modalInfo?.samadCode})
        }
    }, [modalInfo]);

    useEffect(() => {
        if(getOrderedPrescriptionRequest?.isSuccess) {
            setOrderedPrescriptionData(getOrderedPrescriptionRequest?.data?.data?.result);
        }
    }, [getOrderedPrescriptionRequest?.isSuccess]);

    const handleSetShowModal = () => {
        setShowState(false);
        handleHideModal();
    }

    return (
        <Modal
            setShow={handleSetShowModal}
            showState={showState}
            noCloseBtn={true}
            className="w-1000 mw-100"
            bodyClassName="py-5 px-3 px-lg-5 pos-rel"
        >
            <div className='d-flex mb-4 fs-3 px-2'>
                <div className=" px-2 flex-fill align-content-center">
                    <h4 className="d-flex align-items-center title-dot font-16 font-weight-bold">
                        اطلاعات نسخه
                    </h4>
                </div>
                <span className='text-red-hover align-content-center mt-2' onClick={() => handleSetShowModal()}>
                      <Icon name='close-square'/>
                    </span>
            </div>
            {orderedPrescriptionData && (
                <OrderPartnerInfo
                    orderedPrescriptionData={orderedPrescriptionData}
                />
            )}
            {orderedPrescriptionData?.items?.map((item) => {
                const UUID = uuidv4()
                return (
                    <OrderedPrescriptionItem
                        key={UUID}
                        item={item}
                    />
                )
            })}
            <div className="d-flex justify-content-center mt-4 pt-2">
                <button
                    onClick={() => handleSetShowModal()}
                    className="btn btn-outline-gray flex-grow-1 py-2 mx-1"
                >
                    انصراف
                </button>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state: any) => ({
    modalData: modalDataSelector(state),
    modalName: modalNameSelector(state),
    isShowModalData: isShowModalDataSelector(state),
    isHideModalData: isHideModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleHideModal: () => dispatch(general.handleHideModal()),
    handleResetModal: () => dispatch(general.handleResetModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderedPrescriptionInfoModal);
